import { useQuery } from "@tanstack/react-query";
import { useRecoilValue, useSetRecoilState } from "recoil";

import FilterApi from "@/api/FilterApi";
import {
  SecondFilterSelect,
  secondFilterSelectedState,
} from "@/components/filter/secondFilterSelectedState";
import { selectedFiltersSelector } from "@/components/filter/selectedFiltersSelector";

const useFilterQuery = () => {
  const selectedFilters = useRecoilValue(selectedFiltersSelector);
  const setSecondaryFilterItem = useSetRecoilState(secondFilterSelectedState);

  const filterQuery = useQuery(
    ["filterQuery", selectedFilters],
    () => FilterApi.filter(selectedFilters),
    {
      keepPreviousData: true,
    }
  );

  const sizes = filterQuery.data?.data.sizes || [];
  const colors = filterQuery.data?.data.colors || [];
  const discounts = filterQuery.data?.data.discounts || [];
  const stores = filterQuery.data?.data.stores || [];
  const count = filterQuery.data?.data.count;

  const selectedSizes = selectedFilters.sizes || [];
  const selectedColors = selectedFilters.colors || [];
  const selectedDiscounts = selectedFilters.discounts || [];
  const selectedStores = selectedFilters.stores || [];

  const toggleSecondaryFilterItem = (
    categoryId: string | number,
    categoryKey: keyof SecondFilterSelect
  ) => {
    setSecondaryFilterItem((state) => {
      if (!state?.[categoryKey]) return state;

      if (!state[categoryKey].includes(categoryId))
        return { ...state, [categoryKey]: [...state[categoryKey], categoryId] };

      return {
        ...state,
        [categoryKey]: state[categoryKey].filter((item) => item !== categoryId),
      };
    });
  };

  return {
    sizes,
    colors,
    discounts,
    stores,
    selectedSizes,
    selectedColors,
    selectedDiscounts,
    selectedStores,
    toggleSecondaryFilterItem,
    count,
  };
};

export default useFilterQuery;
